import { IsRootPathSegments } from './infos';
import { NormalizePathSegments } from './normalize';
import { SLASH_REGEXP } from './configs';
export function StringPathToPathSegments(path, options) {
    return NormalizePathSegments(StringPathToRawPathSegments(path, options), options);
}
export function StringPathToRawPathSegments(path, options) {
    if (path === '') {
        return [];
    }
    else {
        options.rootRegExp.lastIndex = 0;
        const match = options.rootRegExp.exec(path);
        if (match === null) {
            return path.split(SLASH_REGEXP);
        }
        else {
            path = path.slice(match[0].length);
            return [match[1], ...path.split(SLASH_REGEXP)];
        }
    }
}
export function PathSegmentsToStringPath(path, options) {
    return IsRootPathSegments(path, options)
        ? (path[0] + options.separator)
        : path.join(options.separator);
}
//# sourceMappingURL=convert.js.map